import { render, staticRenderFns } from "./GiftMenu.vue?vue&type=template&id=789cb0b9&scoped=true&"
import script from "./GiftMenu.vue?vue&type=script&lang=js&"
export * from "./GiftMenu.vue?vue&type=script&lang=js&"
import style0 from "./GiftMenu.vue?vue&type=style&index=0&id=789cb0b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789cb0b9",
  null
  
)

export default component.exports